import React from "react";

// Source
import * as HelperSrc from "../HelperSrc";
import StoreRoute from "../store/Route";
import * as ModelRoute from "../model/Route";

export default class ControllerHeader {
    // Variable
    private storeRoute: ModelRoute.Istore<ModelRoute.Idata>;
    private storageRouteData = React.useRef<ModelRoute.Idata | undefined>(undefined);

    private elementMenuButton = React.useRef<HTMLButtonElement | null>(null);
    private elementViewMain = React.useRef<HTMLElement | null>(null);

    private isRendered = React.useRef<boolean>(false);

    getStorageRoute: ModelRoute.Idata | undefined;

    getElementMenuButton: HTMLButtonElement | null;
    setElementMenuButton: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;

    getIsMenuOpen: boolean;
    setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;

    // Method
    constructor(isRendered: boolean) {
        this.storeRoute = new StoreRoute();
        this.storageRouteData.current = this.storeRoute.storageGet();

        this.isRendered.current = isRendered;

        const [getStorageRoute] = React.useState<ModelRoute.Idata | undefined>(this.storageRouteData.current);
        this.getStorageRoute = getStorageRoute;

        const [getElementMenuButton, setElementMenuButton] = React.useState<HTMLButtonElement | null>(null);
        this.getElementMenuButton = getElementMenuButton;
        this.setElementMenuButton = setElementMenuButton;

        const [getIsMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);
        this.getIsMenuOpen = getIsMenuOpen;
        this.setIsMenuOpen = setIsMenuOpen;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            HelperSrc.domObserver(".view_header", () => {
                this.initializeHtmlElement();
            });
        }, []);

        React.useEffect(() => {
            this.storageRouteData.current = this.storeRoute.storageGet();
        }, [this.storageRouteData.current]);
    };

    clickOpenMenu = (): void => {
        this.setIsMenuOpen(true);
    };

    clickCloseMenu = (): void => {
        this.setIsMenuOpen(false);
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMain.current) {
            this.elementMenuButton.current = document.querySelector<HTMLButtonElement>("[name='menu_button']");
            this.elementViewMain.current = document.querySelector<HTMLElement>(".view_header");

            this.setElementMenuButton(this.elementMenuButton.current);
        }
    };
}
